/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconMedicalFormSelect/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconMedicalFormSelect({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconMedicalFormSelect",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconMedicalFormSelect.Svg"
  data-view-path={viewPath}
 viewBox="0 0 15 14"
 style={{'--as-1-Zs3t5d': alignSelf,'--mt-2-Zs3t5d': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Zs3t5d': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Zs3t5d': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Zs3t5d': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Zs3t5d': opacity,'--w-10-Zs3t5d': typeof width === 'number' ? `${width}px` : width,'--h-11-Zs3t5d': typeof height === 'number' ? `${height}px` : height,'--f-12-Zs3t5d': fill,'--a-7-Zs3t5d': isAnimated ? animation : "none",'--sd-8-Zs3t5d': isAnimated ? strokeDashoffset : 0,'--sd-9-Zs3t5d': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconMedicalFormSelect.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M6.5 2a4 4 0 100 8 4 4 0 000-8zm-6 4a6 6 0 1110.89 3.477l2.817 2.816a1 1 0 01-1.414 1.414l-2.817-2.816A6 6 0 01.5 6zm6.516-2.263a.75.75 0 10-1.5 0v2.357c0 .414.335.75.75.75h2.468a.75.75 0 000-1.5H7.016V3.737z"
 style={{'--f-12-Zs3t5d': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}